import { render } from "./OrderStatus.vue?vue&type=template&id=2054f256&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=2054f256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2054f256"]])

export default __exports__